export interface SignupFormData {
  salutation: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  website: string;
  company: string;
  newsletter: boolean;
  partner: string;
  voucher?: string;
}

export interface SignupResponse {
  customId?: string;
  hubspotCompanyId?: string;
  hubspotContactId?: string;
}

export interface PollQuestion {
  step: number;
  type: 'single' | 'multi';
  title: string;
  options: PollOption[];
  allowCustom?: boolean;
}

export interface PollOption {
  value: string;
  label: string;
  icon: string;
}

export enum AppView {
  LANDING = 'landing',
  POLL = 'poll',
  SUCCESS = 'success',
}

export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
  error_code?: string;
  field_errors?: Record<string, string>;
}
